var $       = require( 'jquery' );

$(document).ready( function () {

    $('.set-height').each(function(n,elem){
        var width = $(elem).find('img').width();
        // $(elem).parent().parent().height(width/1.33);

        // Height of the schema car
        if(n===0){
            $(elem).css('height','auto');
        }else{
            $(elem).height(width/1.33);
        }
    });

});

$(window).resize(function(){
    $('.set-height').each(function(n,elem){
        var width = $(elem).find('img').width();
        // $(elem).parent().parent().height(width/1.33);

        // Height of the schema car
        if(n===0){
            $(elem).css('height','auto');
        }else{
            $(elem).height(width/1.33);
        }
    });
});


// WEBPACK FOOTER //
// ./resources/js/set-height.js